/**
 * @overview 远程认证修改成绩
 * @author 3173
 * @date 2020-8-16
 */
import React from 'react';
import {Select } from 'antd';
import ReactDOM from 'react-dom'
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import 'antd/dist/antd.css';
import DataSet from "@antv/data-set";
import { WizModalUserIdentityShow } from '@/containers/common';
import { instanceOf, element } from 'prop-types';
import cloneDeep from 'lodash/cloneDeep'
let { WizContainer, WizReduxTemplatem, modelUtils } = framework_tool;
let { WizCard, WizIcon, WizTable, WizButton, WizModal, WizTabs, WizDataTable, WizSpin, WizInputNumber, WizTimePicker } = component_tool;
let { checkStrLength, getPageData, Session } = utils_tool;


class OrgRemoteEvaluationScore extends WizContainer {

  componentName = 'orgRemoteEvaluationScore';

  constructor(props) {
    super(props);
    let { history } = this.props;
    let initialValue = {};
    if (history && history.location && history.location.pathname === '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationScore') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('orgRemoteEvaluationScore', initialValue)
      } else {
        initialValue = Session.get('orgRemoteEvaluationScore') || {};
      }
    }

    this.state = {
      infoList: [],//考卷模块
      tabIndex: 0,//当前tab标识
      totalScore: (initialValue.score && initialValue.score!=-1) ? initialValue.score : 0//总分
    }
    this.initialValue = initialValue;

  }

  _componentWillMount() {
    const { history } = this.props;
  }

  _componentDidMount() {
    this.getOrgRemoteAuthExamInfo()
  }



  /**获取考卷 */
  getOrgRemoteAuthExamInfo() {
    if (this.initialValue.id) {
      this.doAction({
        path: 'orgRemoteAuthDetail/getOrgRemoteAuthExamInfo',
        payload: {
          key: 'getOrgRemoteAuthExamInfo',
          apiParams: {
            id: this.initialValue.id, //, 11911
            orgId: this.initialValue.orgId, // 02440a2752694f538e6618cc591eb95f
            exam_id:this.initialValue.examId
          }
        },
        autoInit: true,
      })
    }
  }

  /**保存单个模块数据 */
  saveModuleRelation(index) {
    let { infoList, tabIndex } = this.state;
    if (infoList.length > tabIndex) {
      let studentModuleRelation = infoList[tabIndex];
      let answers = this._getAnswers(studentModuleRelation);
      let answersNew = [];
      answers.forEach(e=>{
        e.id = e.questionDetailScoreId
        e.authQuestionDetailId = e.questionDetailId
        e.score = e.questionDetailScore ? e.questionDetailScore : 0
        e.type = 1
        answersNew.push(e);
      })
      this.doAction({
        path: 'authQuestionDetailScore/update',
        payload: {
          key: 'authQuestionDetailScore',
          apiParams: {
            authQuestionDetailScores:answersNew,
            studentRemoteAuthDetailId: this.initialValue.id, 
            entityId: this.initialValue.orgId, 
            remoteAuthId : this.initialValue.remoteAuthId, 
            authState : this.initialValue.authState,
          }
        },
        autoInit: true,
      })
    }
  }



  propsAndStateOnChange = {
    orgRemoteAuthExamInfo: this.getOrgRemoteAuthExamInfoOver.bind(this),
    authQuestionDetailScoreInfo: this.authQuestionDetailScoreOver.bind(this)
  };


  /**
   * 获取考卷返回结果
   * @param nextProps
   * @param nextState
   */
   getOrgRemoteAuthExamInfoOver(nextProps, nextState) {
    if (nextProps.orgRemoteAuthExamInfo.code == 1) {
      let infoList = nextProps.orgRemoteAuthExamInfo.data;
      let examInfoList = infoList && infoList instanceof Array ?cloneDeep(infoList):[]; 
      examInfoList.forEach(element=>{
          if(element.answers && element.answers instanceof Array ){
            element.answers.forEach(answer=>{
              if(answer.score && answer.score<0){
                answer.score = undefined;
              }
            })
          }
      })
      nextState.infoList = examInfoList;
    } else {
      wizNotice.error('考卷加载失败：' + nextProps.studentRemoteAuthExamInfo.msg);
    }
    return true;
  }

  authQuestionDetailScoreOver(nextProps, nextState) {
    if (nextProps.authQuestionDetailScoreInfo.code == 1) {
      wizNotice.success('操作成功')
      nextState.totalScore = nextProps.authQuestionDetailScoreInfo.data ? nextProps.authQuestionDetailScoreInfo.data :0
    } else {
      wizNotice.error('保存失败');
    }
    return true;
  }


  _onChange = (key) => {
    if (this.state.tabIndex !== key) {
      this.setState({
        tabIndex: key,
        time: new Date().getTime()
      });
    }
  }

  _getAnswers = (studentModuleRelation)=>{
    let answers = [];
    if (studentModuleRelation && studentModuleRelation.module instanceof Array) {
      studentModuleRelation.module.forEach(moduleInfo => {
        moduleInfo.question.forEach(question=>{
          question.questionDetail.forEach(questionDetail=>{
            answers.push(questionDetail);
          })
        })
      });
    }
    return answers;
  }

  /** 改变行分数 */
  scoreChange(record, score) {
    let { infoList, tabIndex, totalScore } = this.state;
    let neoInfoList = cloneDeep(infoList);
    let neoTotalScore = totalScore;
    if (neoInfoList.length > tabIndex) {
      let studentModuleRelation = Object.assign({}, neoInfoList[tabIndex]);
      let neoValue = Object.assign([], this._getAnswers(studentModuleRelation));
      neoValue.forEach((value, index) => {
        if (value.questionDetailId === record.questionDetailId) {
          var regex = /^\d*(\.[1-9]|\.\d[1-9])*$/
          if( score==''|| !score){
            neoTotalScore = neoTotalScore -  (value.questionDetailScore?value.questionDetailScore:0 );
            neoTotalScore = neoTotalScore ? neoTotalScore.toFixed(1):0;
            value.questionDetailScore = score;
          }else if((score || score==0 )&& regex.test(score) && score!=''){
            neoTotalScore = neoTotalScore - (value.questionDetailScore?value.questionDetailScore:0 ) + score;
            neoTotalScore = neoTotalScore ? neoTotalScore.toFixed(1):0;
            value.questionDetailScore = score;
          }
        }

      });
      studentModuleRelation.answers = neoValue;
      neoInfoList[tabIndex] = studentModuleRelation;
      this.setState({ infoList: neoInfoList , totalScore:neoTotalScore });
    }
  }

  createKeyValue =(key, value)=>{
    let keyValue = {};
    keyValue[key] = value;
    return keyValue;
  }

  /** 创建表头 */
  createColumns() {
    let { infoList, tabIndex } = this.state;
    let columns = [];
    if (infoList.length > tabIndex && infoList[tabIndex]) {
      let studentModuleRelation = infoList[tabIndex];
      let answers = [];
      let answersObj = {};
      let moduleObj = {};
      if (studentModuleRelation && studentModuleRelation.module instanceof Array) {
        let questionRowNum = 0;
        studentModuleRelation.module.forEach(moduleInfo => {
          let moduleKeyValue = this.createKeyValue(questionRowNum,moduleInfo);
          moduleObj = {...moduleObj,...moduleKeyValue}
          moduleInfo.question.forEach(question=>{
            question.questionDetail.forEach(questionDetail=>{
              answers.push(questionDetail);
            })
            let questionKeyValue = this.createKeyValue(questionRowNum,question);
            answersObj = {...answersObj,...questionKeyValue}
            questionRowNum = questionRowNum+question.questionDetail.length
          })
          
        });
        // dataItems.forEach(element => {
        //   element.key = new Date().getTime()
        // });
      }

      columns = [
        {
        title: '二级目录',
        name: 'moduleName',
        dataIndex: "moduleName",
        render(value, row, index) {
          const obj = {
            children: undefined,
            props: { rowSpan: 0 },
          };
          // if (index == 0) {
          //   let moduleValue = moduleObj[0]
          //   let moduleLength = 0
          //   moduleValue.question.forEach(e=>{
          //     moduleLength = moduleLength+ e.questionDetail.length
          //   })
          //   obj.children = <div dangerouslySetInnerHTML={{__html: moduleValue.moduleName}}></div>,
          //   obj.props.rowSpan = moduleLength;
          // }else if(answers.length>index+1){
          //   Object.keys(moduleObj).forEach(_index =>{
          //     if(_index==index+''){
          //       let moduleValue = moduleObj[index]
          //       let moduleLength = 0
          //       moduleValue.question.forEach(e=>{
          //         moduleLength = moduleLength+ e.questionDetail.length
          //       })
          //       obj.children = <div dangerouslySetInnerHTML={{__html: moduleValue.moduleName}}></div>,
          //       obj.props.rowSpan = moduleLength;
          //     }
          //   })
          // }

          Object.keys(moduleObj).forEach(_index =>{
            if(_index==index+''){
              let moduleValue = moduleObj[index]
              let moduleLength = 0
              moduleValue.question.forEach(e=>{
                moduleLength = moduleLength+ e.questionDetail.length
              })
              obj.children = <div dangerouslySetInnerHTML={{__html: moduleValue.moduleName}}></div>,
              obj.props.rowSpan = moduleLength;
            }
          })
          return obj
        }
      },
      {
        title: '三级目录',
        name: 'questionName',
        dataIndex: "questionName",
        render: (value, row, index) => {
          const obj = {
            children: undefined,
            props: { rowSpan: 0 },
          };
          // if (index == 0) {
          //   let questionValue = answersObj[0]
          //   obj.children = <div dangerouslySetInnerHTML={{__html: questionValue.questionId}}></div>,
          //   obj.props.rowSpan = questionValue.questionDetail.length;
          // }else 
          // if(answers.length>index+1){
          //   Object.keys(answersObj).forEach(_index =>{
          //     if(_index==index+''){
          //       let questionValue = answersObj[index]
          //       obj.children = <div dangerouslySetInnerHTML={{__html: questionValue.questionId}}></div>,
          //       obj.props.rowSpan = questionValue.questionDetail.length;
          //     }
          //   })
          // }

          Object.keys(answersObj).forEach(_index =>{
            if(_index==index+''){
              let questionValue = answersObj[index]
              obj.children = <div dangerouslySetInnerHTML={{__html: questionValue.questionName}}></div>,
              obj.props.rowSpan = questionValue.questionDetail.length;
            }
          })
          return obj
        }
      },
      {
        title: '指标',
        name: 'questionTarget',
        dataIndex: "questionTarget",
        width: '20%',
        render: (value, row, index) => {
          const obj = {
            children: undefined,
            props: { rowSpan: 0 },
          };
          Object.keys(answersObj).forEach(_index =>{
            if(_index==index+''){
              let questionValue = answersObj[index]
              obj.children = <div dangerouslySetInnerHTML={{__html: questionValue.questionTarget}}></div>,
              obj.props.rowSpan = questionValue.questionDetail.length;
            }
          })
          return obj
        }
      },
      {
        title: '指标要求',
        name: 'questionRequirements',
        dataIndex: "questionRequirements",
        width: '30%',
        render: (value, row, index) => {
          const obj = {
            children: undefined,
            props: { rowSpan: 0 },
          };
          Object.keys(answersObj).forEach(_index =>{
            if(_index==index+''){
              let questionValue = answersObj[index]
              obj.children = <div dangerouslySetInnerHTML={{__html: questionValue.questionRequirements}}></div>,
              obj.props.rowSpan = questionValue.questionDetail.length;
            }
          })
          return obj
        }
      },
      // {
      //   title: '序号',
      //   name: 'number',
      //   dataIndex: "number",
      //   render: (value, row, index) => { return index  }
      // },
      {
        title: '失分点',
        name: 'questionDetailContent',
        dataIndex: "questionDetailContent",
        width: '20%',
        render: (value, row, index) => {
          const obj = {
            children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
            props: {},
          };
          return obj;
        }
      },
      {
        title: '考点得分',
        name: 'questionDetailScore',
        dataIndex: "questionDetailScore",
        width: '10%',
        render: (text, record) =>{ 
          let score = record.questionDetailScore
          if(score==-1 || !score){
            score = 0;
          }
          let one = 1;
          let zero = 0;
          return ( 
            //(record.maxScore && record.maxScore >= 0) || record.maxScore == 0 ? record.maxScore : 0
         // <WizInputNumber  max={1} value={score} precision={1} onChange={(value) => { this.scoreChange(record, value) }}/>
          <Select
         // size="small"
          style={{width:"70px"}}
          defaultValue={score}
          onChange={(value) => {this.scoreChange(record, value) }}
        >
          <Option value={one}>
            1
          </Option>
          <Option value={zero}>
            0
          </Option>
        </Select>  

        )
      }
      },

      ]
    }
    return columns;
  }


  /**列表 */
  detailList() {
    const { history, studentRemoteAuthDetailLoading } = this.props;
    let { infoList, tabIndex } = this.state;

    let columns = this.createColumns(tabIndex);

    let dataItems = [];
    if (infoList.length > tabIndex) {
      let studentModuleRelation = infoList[tabIndex];
      if (studentModuleRelation && studentModuleRelation.module instanceof Array) {
        dataItems = this._getAnswers(studentModuleRelation);
        dataItems.forEach(element => {
          element.key = new Date().getTime()
        });
      }
    }

    let dataTableProps = {
      loading: false,
      columns,
      dataSource: dataItems,
      rowKey: "id",
      //selectType: "checkbox",
      rowSelection: null,
      showNum: false,
      isScroll: true,
      reasonable: true,
      pagination: false,
      scroll:{ y: true },
      // onChange: ({pageNum, pageSize}) => {
      //   this.detailList(null, {current: pageNum, size: pageSize});
      // },

    };
    return (
      <>
        <WizCard className="mt-15">
          <WizTable {...dataTableProps} />
          {this.sumbitBtn()}
        </WizCard>
      </>
    )
  }

  sumbitBtn(){
    let { infoList, tabIndex } = this.state;
    if(infoList && infoList.length>0){
      return (
        <div className="sumbit-btns">
        <WizButton style={{marginLeft:'45%',marginTop:'10px'}} type="primary" className="button"  onClick={() => this.saveModuleRelation()}>保存</WizButton>
        </div>
      )
    }
  }


  /** 根据数据加载tab内容 */
  setTabs() {
    let { infoList, tabIndex } = this.state;
    let tabs = [];
    if (infoList.length > 0) {
      for (let i = 0; i < infoList.length; i++) {
        let studentModuleRelation = infoList[i];
        tabs.push(<WizTabs.TabPane tab={studentModuleRelation.examName} key={i}>{this.detailList(i)}</WizTabs.TabPane>)
      }
    }else{
      tabs.push(<WizTabs.TabPane tab={'暂无数据'} key={'notData'}>{this.detailList()}</WizTabs.TabPane>)
    }
    return tabs;
  }

  tabBarExtraContent(){
    return(<span style={{marginRight:40}}>
      <span className=" ant-tabs-tab" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight:600,}}>总分:</span>
      <span className=" ant-tabs-tab" > {this.state.totalScore}</span>
      </span>
    )
  }

  _render() {
    const { history, studentRemoteAuthDetailLoading ,studentModuleRelationLoading,authQuestionDetailScoreLoading} = this.props;
    let { totalScore, infoList } = this.state;

    return (
      <WizSpin tip={'加载中'} spinning={studentRemoteAuthDetailLoading || studentModuleRelationLoading || authQuestionDetailScoreLoading}>
        <WizCard>
          <WizTabs animated={false} defaultActiveKey={infoList.length > 0 ? 0 : null} onChange={this._onChange.bind(this)}
            tabBarExtraContent={this.tabBarExtraContent()} >
            {this.setTabs()}
          </WizTabs>
        </WizCard>
      </WizSpin>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  const { studentRemoteAuthDetail, studentModuleRelation,orgRemoteAuthDetail,authQuestionDetailScore } = state;
  const orgRemoteAuthExamInfo = modelUtils.getModelEntity(orgRemoteAuthDetail, "getOrgRemoteAuthExamInfo");
  const authQuestionDetailScoreInfo = modelUtils.getModelEntity(authQuestionDetailScore, "authQuestionDetailScore");
  const load = modelUtils.getLoadingState(state, ['studentRemoteAuthDetail', 'studentModuleRelation','authQuestionDetailScore']);
  return {
    orgRemoteAuthExamInfo: orgRemoteAuthExamInfo,
    authQuestionDetailScoreInfo: authQuestionDetailScoreInfo,
    ...load
  }
};

export default connect(mapStateToProps)(OrgRemoteEvaluationScore);

